var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"back_top"},[_c('div',{staticClass:"back_top_item",on:{"click":function($event){return _vm.goTop()}}},[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":require("../assets/imgaes/top.png")}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }